var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.TheSp.inside_navigate_p)?_c('div',{staticClass:"NavigateBlock"},[_c('div',{staticClass:"NavigateBlockInside"},[(_vm.TheSp.inside_controller_p)?_c('SpController'):_vm._e(),(_vm.TheSp.inside_slider_p)?_c('SpSlider',{ref:"SpSlider"}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }